import styled from "styled-components";

export interface LiveCasinoGridItemInfoItemDefaultBoxProps {
    isLiveStreamOverlay?: boolean;
}

export const LiveCasinoGridItemInfoItemDefaultBox = styled.div<LiveCasinoGridItemInfoItemDefaultBoxProps>`
  display: flex;
  align-items: center;
  margin: ${props => props.isLiveStreamOverlay ? '0 0.75em 0 0.75em' : '0 1em 0 0'};
  color: ${props => props.theme.colors.textLight};
  letter-spacing: 0.1rem;
  font-size: 1em;
  height: 24px;
`;